import React, { useEffect, useState } from "react";
import Nav from "../components/site/Nav";
import Hero from "../components/site/Hero";
import Impact from "../components/site/Impact";
import Profile from "../components/site/Profile";
import Timeline from "../components/site/Timeline";
import Goalkeepers from "../components/site/Goalkeepers";
import Development from "../components/site/Development";
import Methodology from "../components/site/Methodology";
import Process from "../components/site/Process";
import Education from "../components/site/Education";
import References from "../components/site/References";
import MediaSection from "../components/site/Media";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";
import { api } from "../lib/api";
import { useLang } from "../context/LangContext";

const DEFAULT_HERO =
  "https://images.unsplash.com/photo-1517927033932-b3d18e61fb3a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxnb2Fsa2VlcGVyJTIwZm9vdGJhbGwlMjBhY3Rpb24lMjBjaW5lbWF0aWN8ZW58MHx8fHwxNzgzODkwMjE0fDA&ixlib=rb-4.1.0&q=85";
const DEFAULT_PROFILE =
  "https://images.pexels.com/photos/20836662/pexels-photo-20836662.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const Home = () => {
  const { lang } = useLang();
  const [content, setContent] = useState({
    clubs: [],
    goalkeepers: [],
    developed: [],
    references: [],
    education: [],
    media: [],
    settings: {},
  });

  useEffect(() => {
    api
      .get("/content")
      .then((r) => setContent(r.data))
      .catch(() => {});
  }, []);

  useEffect(() => {
    const isEs = lang === "es";
    const title = isEs
      ? "Robert Prieto Deuma · Entrenador Profesional de Porteros · Licencia PRO INAF"
      : "Robert Prieto Deuma · Professional Goalkeeper Coach · INAF PRO License";
    const desc = isEs
      ? "Robert Prieto Deuma, entrenador profesional de porteros chileno con +15 años en el fútbol profesional. Licencia PRO INAF. Universidad Católica · Deportes Antofagasta · Unión Española."
      : "Robert Prieto Deuma — Chilean Professional Goalkeeper Coach with 15+ years in professional football. INAF PRO License. Universidad Católica · Deportes Antofagasta · Unión Española.";
    const ogLocale = isEs ? "es_CL" : "en_US";
    const ogLocaleAlt = isEs ? "en_US" : "es_CL";

    document.title = title;
    document.documentElement.lang = isEs ? "es" : "en";

    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [k, v] = selector.replace(/[[\]"']/g, "").split("=");
        el.setAttribute(k, v);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]', "content", desc);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", desc);
    setMeta('meta[property="og:locale"]', "content", ogLocale);
    setMeta('meta[property="og:locale:alternate"]', "content", ogLocaleAlt);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", desc);

    // Dynamic canonical/OG URL based on current origin (helps when domain changes)
    const origin = window.location.origin;
    setMeta('meta[property="og:url"]', "content", `${origin}/`);
    const canonical = document.head.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", `${origin}/`);
  }, [lang]);

  const hero = content.settings?.hero_image_url || DEFAULT_HERO;
  const heroImages = Array.isArray(content.settings?.hero_images)
    ? content.settings.hero_images
    : [];
  const profile = content.settings?.profile_image_url || DEFAULT_PROFILE;

  return (
    <div className="min-h-screen bg-[color:var(--rp-bg)] text-white">
      <Nav />
      <main>
        <Hero heroImage={hero} heroImages={heroImages} />
        <Impact />
        <Profile profileImage={profile} />
        <Timeline clubs={content.clubs} />
        <Goalkeepers goalkeepers={content.goalkeepers} />
        <Development developed={content.developed} />
        <Methodology />
        <Process />
        <Education education={content.education} />
        <References references={content.references} />
        <MediaSection media={content.media} />
        <Contact settings={content.settings} />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
